import './css/ConfigFollowLevelList.css'

import React from "react"
import { SketchPicker } from 'react-color';
import { Input, Button, Table, Space, Form, message } from 'antd'
import { FormInstance } from "antd/lib/form"
import Modal from "antd/lib/modal/Modal"
import axios, { axiosTable, baseAxiosComplete } from '../../tool/axios'
import BreadCrumb from '../../component/BreadCrumb'
import { formItemLayout, tailLayout } from '../../js/globalParam'

const { Column } = Table

interface State {
    data: object[],
    loading: boolean,
    type: string | null,
    pagination: {
        current: number,
        pageSize: number,
        total: number
    },
    item: any,
    fetchOtherParams: {
        store_name: string | null,
        item_type: string | null,
        flag_name: string | null,
        item_name: string | null,
        item_status: string | null
    },
    formParams: {
        item_type: string | null
    },
    addVisible: false
}

export default class CkOrderList extends React.Component {
    state: State = {
        data: [],
        loading: false,
        type: 'add',
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0
        },
        item: {
            follow_level: null,
            order_num: null,
            color_code: ''
        },
        fetchOtherParams: {
            item_type: null,
            item_name: null,
            flag_name: null,
            store_name: null,
            item_status: null
        },
        formParams: {
            item_type: null
        },
        addVisible: false
    }

    formRef = React.createRef<FormInstance>()

    componentDidMount() {
        const { pagination, fetchOtherParams } = this.state
        this.fetch({ pagination, fetchOtherParams })
    }

    handleTableChange = (antPagination: any) => {
        const { fetchOtherParams, pagination } = this.state
        pagination.current = antPagination.current
        this.fetch({
            pagination,
            fetchOtherParams
        })
    }

    handleColorChange = (colorCode: any) => {
        let { item } = this.state
        item.color_code = colorCode.hex

        this.setState({ item })
    }

    fetch({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) {
        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        axiosTable.get('/markting_center/follow_level/page_list', {
            params: {
                ...iPagination,
                ...fetchOtherParams
            }

        }).then((response: any) => {
            if (response) {
                const { pagination } = this.state

                pagination.total = response.total
                pagination.pageSize = response.size
                pagination.current = response.current

                this.setState({
                    pagination,
                    data: response.records
                })
            }
        })
    }

    reviewDetail(item: object | any) {
        axiosTable.get("/markting_center/follow_level/detail", { params: { id: item.id } }).then((res: any) => {
            item = res;
        }).then(() => {
            this.setState({
                item,
                type: 'edit',
                addVisible: true
            })
            this.setState({ addVisible: true }, () => {
                for (let i in this.state.item) {
                    this.formRef.current?.setFieldsValue({ [i]: item[i] })
                }
            })
        })
    }

    selectState(type: string) {
        let { pagination, fetchOtherParams } = this.state;
        if (type != 'current') {
            pagination.current = 1;
        }

        this.fetch({
            pagination,
            fetchOtherParams
        })
    }

    // 是否为正整数
    isPositiveInteger(val: any) {
        var re = /^[1-9]{1,5}$/;
        return re.test(val)
    }

    confirmAdd(value: any) {
        let { item } = this.state;
        let current: any = this.formRef.current;
        let obj: object | any = {}
        let url: string = ''

        if (!this.isPositiveInteger(current.getFieldValue('order_num'))) {
            message.error('请输入大于0的正整数')
            this.formRef.current?.setFieldsValue({ order_num: null })
            return;
        }

        for (let i in item) {
            if (i == 'color_code' && typeof current.getFieldValue(i) != 'string') {
                obj[i] = current.getFieldValue(i).hex

            } else {
                obj[i] = current.getFieldValue(i)
            }
        }

        if (obj.id) {
            url = '/markting_center/follow_level/update'

        } else {
            url = '/markting_center/follow_level/add'
        }

        baseAxiosComplete.post(url, obj).then((res) => {
            if (res.status != 500507) {
                const { pagination, fetchOtherParams } = this.state
                this.fetch({ pagination, fetchOtherParams })

                this.closeModal()
            }
        })
    }

    closeModal() {
        for (let i in this.state.item) {
            this.formRef.current?.setFieldsValue({ [i]: '' })
        }

        this.setState({
            addVisible: false,
            item: {
                follow_level: null,
                order_num: null,
                color_code: ''
            }
        })
    }

    delItem(id: string) {
        axios.post('/markting_center/follow_level/delete', { id: id }).then((response: any) => {
            this.selectState('current')
        })
    }

    render() {
        return (<div className="common-page">
            {/* 营销中心 -> 营销配置 -> 跟进等级配置 */}
            <BreadCrumb position={['营销中心', '跟进等级配置']} />

            <div className="common-top-form">
                <Space direction="horizontal" wrap>
                    <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary" onClick={() => { this.setState({ addVisible: true, type: 'add' }) }}>添加</Button>
                </Space>
            </div>

            <div className="common-main">
                <Table dataSource={this.state.data} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={this.state.pagination} onChange={this.handleTableChange.bind(this)}>
                    <Column title="跟进等级" dataIndex="follow_level" key="follow_level" />
                    <Column title="标签颜色" dataIndex="flag_type" key="flag_type" render={(text, record: any) => {
                        return (
                            <div className="tag" style={{ background: record.color_code }}></div>
                        )
                    }} />

                    {/* <Column
                        title="更新人"
                        key="action"
                        render={(text, record: any) => (
                            record.update_user_name ? <div>{record.update_user_name}</div> : <div>{record.create_user_name}</div>
                        )}
                    /> */}
                    <Column
                        title="更新时间"
                        key="action"
                        render={(text, record: any) => (
                            record.update_time ? <div>{record.update_time}</div> : <div>{record.create_time}</div>
                        )}
                    />

                    {/* <Column
                        title="操作"
                        key="action"
                        render={(text, record: any) => (
                            <Space size="middle">
                                <Button type="primary" onClick={this.reviewDetail.bind(this, record)}>编辑</Button>
                                <Button type="primary" danger onClick={this.delItem.bind(this, record.id)}>删除</Button>
                            </Space>
                        )}
                    /> */}
                </Table>
            </div>

            {/* 新增或编辑 */}
            <Modal title={(this.state.type == 'edit' ? "编辑" : "新增") + '跟进等级'} visible={this.state.addVisible} footer={false} width="500px" onCancel={this.closeModal.bind(this)}>
                <Form name="validate_other" ref={this.formRef} {...formItemLayout} onFinish={this.confirmAdd.bind(this)}>
                    <Form.Item label="跟进等级" name="follow_level" rules={[{ required: true, message: '必须选择跟进等级' }]}>
                        <Input maxLength={10} placeholder="跟进等级" />
                    </Form.Item>

                    <Form.Item label="排序" name="order_num" rules={[{ required: true, message: '必须填写排序' }]}>
                        <Input placeholder="排序" />
                    </Form.Item>

                    <Form.Item label="标签颜色" name="color_code" rules={[{ required: true, message: '必须选择标签颜色' }]}>
                        <SketchPicker color={this.state.item.color_code as any} onChange={this.handleColorChange} />
                    </Form.Item>

                    <Form.Item {...tailLayout}>
                        <Button type="primary" htmlType="submit">提交</Button>
                    </Form.Item>
                </Form>
            </Modal>
        </div>)
    }
}